module.exports = __webpack_public_path__ + "static/media/umbrella.b7876141.png";